/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Badge } from "antd-mobile";
import { IconContext } from "react-icons";
import Color from "../utils/Color";

const StyledContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  color: ${props => (props.isSelected ? props.selectedColor : props.color)};
`;

const StyledIconContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 2.7em;
  height: 2.7em;
  margin-bottom: 4px;
  background: ${props => (props.isSelected ? props.selectedColor : "white")};
  box-shadow: 0 4px 6px -5px grey;
`;

const StyledTitleContainer = styled.span`
  font-size: 0.92em;
`;

class TabItem extends Component {
  render() {
    const {
      index,
      currentIndex,
      icon,
      color,
      selectedColor,
      title,
      onClick,
      badgeCount,
      redDot
    } = this.props;
    const isSelected = index === currentIndex;

    return (
      <StyledContainer
        onClick={() => {
          onClick && onClick(index);
        }}
        isSelected={isSelected}
        color={color}
        selectedColor={selectedColor}
      >
        <StyledIconContainer
          isSelected={isSelected}
          color={color}
          selectedColor={selectedColor}
        >
          <IconContext.Provider
            value={{
              color: isSelected ? "white" : color,
              size: "1.4em"
            }}
          >
            {icon}
          </IconContext.Provider>
          {badgeCount > 0 ? (
            <Badge
              text={badgeCount}
              style={{
                backgroundColor: Color.highlightRedTextColor,
                color: "white",
                fontSize: "0.75em",
                position: "absolute",
                top: -1,
                right: -10
              }}
            />
          ) : null}
          {redDot ? (
            <Badge
              dot
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: Color.highlightRedTextColor,
                color: "white",
                fontSize: "0.8em",
                position: "absolute",
                top: -1,
                right: -10
              }}
            />
          ) : null}
        </StyledIconContainer>
        <StyledTitleContainer>{title}</StyledTitleContainer>
      </StyledContainer>
    );
  }
}

TabItem.propTypes = {
  index: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  icon: PropTypes.element.isRequired,
  color: PropTypes.string.isRequired,
  selectedColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  badgeCount: PropTypes.number,
  redDot: PropTypes.bool
};

TabItem.defaultProps = {
  badgeCount: 0
};

export default TabItem;



// WEBPACK FOOTER //
// ./src/components/TabItem.js